import type {
  ClientJourneyPresentationV1,
  ExternalAfterFixProofClientSafeSummaryV1,
  ExternalProofSalesRoomClientSafeViewV1,
} from "@enrein/shared-contracts";
import type { ClientPortalShellViewV1 } from "@enrein/shared-contracts/client-link";
import type { DeployEnvironment } from "@enrein/shared-contracts/deploy-env";
import type { PreviewViewV1 } from "@enrein/shared-contracts/approval-change";
import type { ClientPortalApiClient } from "../../api.js";

export type V10ClientLinkLocationContext = {
  readonly clientLinkId: string;
  readonly token: string;
};

export type V10ClientLinkViewProps = {
  readonly shell: ClientPortalShellViewV1;
  readonly preview: PreviewViewV1 | null;
  readonly sessionToken: string;
  readonly locationContext: V10ClientLinkLocationContext;
  readonly externalProofView: ExternalProofSalesRoomClientSafeViewV1 | null;
  readonly afterFixProofSummary: ExternalAfterFixProofClientSafeSummaryV1 | null;
  readonly deployEnv: DeployEnvironment;
  readonly changeMessage: string;
  readonly setChangeMessage: (value: string) => void;
  readonly onApprove: () => void;
  readonly onRequestChange: () => void;
  readonly actionStatus: string | null;
  readonly onActionStatus: (message: string | null) => void;
  readonly isExternalProof: boolean;
  readonly api: ClientPortalApiClient;
  /** Server-composed journey presentation — render only; never re-derive run/QA locally. */
  readonly journeyPresentation?: ClientJourneyPresentationV1 | null;
};

export const V10_CLIENT_TABS = [
  "intake",
  "summary",
  "preview",
  "proof",
  "record",
  "changes",
  "requests",
  "handoff",
] as const;

export type V10ClientTabId = (typeof V10_CLIENT_TABS)[number];

export function v10LinkIdFromContext(locationContext: V10ClientLinkLocationContext): string {
  return locationContext.clientLinkId;
}
